import VacanciesService from '@/services/VacanciesService.js'
import ContactService from '@/services/ContactService.js'

export const namespaced = true

export const LoadingState = Object.freeze({
  Nothing: 'nothing',
  Pending: 'pending',
  Success: 'success',
  Error: 'error',
})

export const state = {
  vacancies: null,
  loadingState: LoadingState.Nothing,
}

export const getters = {
  vacanciesAreLoaded: state => state.vacancies && typeof state.vacancies === 'object',
  findVacancy: state => id => state.vacancies.find(v => v.id === id),
  vacancies: state => state.vacancies,
  filterVacancies: (state, _getters, _rootState, rootGetters) => searchTerm =>
    state.vacancies.filter(v => {
      const containsSearchTerm = v.title.toLowerCase().includes(searchTerm.toLowerCase())
      const isAllowedToSee = rootGetters['auth/signedIn'] || !v.hidden
      return containsSearchTerm && isAllowedToSee
    }),
  loadingState: state => state.loadingState,
}

export const mutations = {
  SET_VACANCIES: (state, vacancies) => (state.vacancies = vacancies),
  ADD_VACANCY: (state, vacancy) => state.vacancies.push(vacancy),
  REMOVE_VACANCY: (state, id) => (state.vacancies = state.vacancies.filter(v => v.id !== id)),
  UPDATE_VACANCY: (state, vacancy) => {
    state.vacancies = state.vacancies.filter(v => v.id !== vacancy.id)
    state.vacancies.push(vacancy)
  },
  REMOVE_REACTION: (state, { vacancyId, reactionId }) => {
    const vacancy = state.vacancies.find(v => v.id === vacancyId)
    vacancy.reactions.items = vacancy.reactions.items.filter(r => r.id !== reactionId)
  },
}

export const actions = {
  maybeFetchVacancies: async ctx => {
    if (ctx.getters.vacanciesAreLoaded) {
      return
    } else {
      return await ctx.dispatch('fetchVacancies')
    }
  },
  fetchVacancies: ctx => {
    const loggedIn = ctx.rootGetters['auth/loggedIn']
    const fetchPromise = loggedIn
      ? VacanciesService.fetchVacancies
      : VacanciesService.fetchPublicVacancies
    return fetchPromise().then(response => {
      ctx.commit('SET_VACANCIES', response)
    })
  },
  createVacancy: async (ctx, vacancy) => {
    const response = await VacanciesService.createVacancy(vacancy)
    vacancy.id = response.id
    vacancy.reactions = { items: null }
    ctx.commit('ADD_VACANCY', vacancy)
  },
  updateVacancy: async (ctx, vacancy) => {
    const result = await VacanciesService.updateVacancy(vacancy)
    ctx.commit('UPDATE_VACANCY', vacancy)
    return result
  },
  deleteVacancy: async (ctx, vacancyId) => {
    await VacanciesService.deleteVacancy(vacancyId)
    ctx.commit('REMOVE_VACANCY', vacancyId)
  },

  deleteReaction: async (ctx, payload) => {
    const { reactionId } = payload
    await ContactService.deleteVacancyReaction(reactionId)
    ctx.commit('REMOVE_REACTION', payload)
  },
}
